import {IMethodRequest, IResponseCustomAction} from "./index";

export const GET_PROVIDERS = 'providers/GET_PROVIDERS'
export const GET_ALL_PROVIDERS = 'providers/GET_ALL_PROVIDERS'

// Unfiltered list, fetched on app load so the provider page can render
// (and its photos are cached) before its filtered request comes back.
export const prefetchAllProviders = (): IResponseCustomAction<string> => {
  return {
    method: IMethodRequest.GET,
    endpoint: 'providers',
    type: GET_ALL_PROVIDERS
  }
}

export const fetchProviders = (appointment_type_id?: number, questionnaire_id?: number): IResponseCustomAction<string> => {
  return {
    method: IMethodRequest.GET,
    endpoint: 'providers',
    qsParams: {
      appointment_type_id,
      questionnaire_id,
    },
    type: GET_PROVIDERS
  }
}